<template>
  <l-cache :get-data="getOrganization" :id="$route.query.id" ref="cache">
    <CooperateOrganizationDetail :group="data" :type="type" @refresh="$refs.cache.retry()" slot-scope="{data}"></CooperateOrganizationDetail>
  </l-cache>
</template>

<script>
  import {Group} from '../../../object'
  import CooperateOrganizationDetail from './cooperateOrganizationDetail'
  export default {
    name: 'cooperateOrganizationDetailBox',
    components: {CooperateOrganizationDetail},
    data: () => ({
      type:'cooperateOrganization',
    }),
    methods: {
      async getOrganization () {
        let res = await this.$store.dispatch('userAdmin/getOrgListByName', {
          pagination: {page: 1, rowsPerPage: 10},
          id: this.$route.query.id,
          name: '',
          type: 'org'
        })
        let items
        if (res.data.status === 1) {
          items = res.data.data.content
        }
        else {
          this.$L.alert('error', {message: '查询合作单位失败,原因:' + res.data.msg})
        }
        if (items && items.length > 0) {
          let p = items[0]
          return Group.fromAPI(p)
        }
        else {
          throw Error('未找到该分组')
        }
      },

    }
  }
</script>

<style scoped>

</style>
